import ModalDeleteData from "./ModalDeleteData";

export default ModalDeleteData;
